export class HttpError extends Error {
  code?: string;
  statusCode: number;

  constructor(statusCode: number, message?: string, stack?: string) {
    super(message);
    this.statusCode = statusCode;

    if (stack) {
      this.stack = stack;
    }

    if (statusCode === 504) {
      this.code = 'ETIMEDOUT';
    } else if (statusCode === 502) {
      this.code = 'ECONNREFUSED';
    } else if (statusCode === 503) {
      this.code = 'ESERVICE_UNAVAILABLE';
    }
  }
}



// WEBPACK FOOTER //
// ./src/gs-core/common/models/http.error.ts